/*
 * VerificationDeclineForm Messages
 *
 * This contains all the text for the VerificationDeclineForm component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.VerificationsPage.VerificationFileFields';

export default defineMessages({
  declineTitle: {
    id: `${scope}.declineTitle`,
    defaultMessage: 'Decline',
  },
  declineButton: {
    id: `${scope}.declineButton`,
    defaultMessage: 'Decline',
  },
  reasonDropDownLabel: {
    id: `${scope}.reasonDropDownLabel`,
    defaultMessage: 'Please specify a reason for declining',
  },
});
